var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React, { Suspense } from "react";
import { GlobalContext } from "../Utils/contexts";
import { getTooltipStyles } from "./tooltipStyles";
const lazyWithPreload = (factory) => {
  const Component = React.lazy(factory);
  Component.preload = factory;
  return Component;
};
const ToolTipComponent = lazyWithPreload(async () => {
  const result = await import(
    /* webpackChunkName: "react-portal-tooltip" */
    "react-portal-tooltip"
  );
  return result.default?.default ? result.default : result;
});
class Tooltip extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "disabled", false);
    __publicField(this, "mousePosition", { x: 0, y: 0 });
    __publicField(this, "timeoutId");
    __publicField(this, "state", {
      tooltipVisible: false
    });
    __publicField(this, "showTooltip", (e) => {
      ToolTipComponent.preload();
      if (!e.target.disabled) {
        this.mousePosition = { x: e.pageX, y: e.pageY };
        this.timeoutId = setTimeout(() => {
          this.setState({ tooltipVisible: true }, () => {
            this.forceUpdate();
            setTimeout(() => this.props.followMouse && this.updateTooltipPosition());
          });
        }, 300);
      }
    });
    __publicField(this, "onMouseMove", (e) => {
      if (this.props.followMouse) {
        this.mousePosition = { x: e.pageX, y: e.pageY };
        this.updateTooltipPosition();
      }
    });
    __publicField(this, "updateTooltipPosition", () => {
      const { x, y } = this.mousePosition;
      const element = document.querySelector(".ToolTipPortal > div");
      if (element) {
        const { offsetWidth: width, offsetHeight: height } = element;
        element.style.left = `${x - width / 2}px`;
        element.style.top = `${y - height - 25}px`;
      }
    });
    __publicField(this, "hideTooltip", () => {
      clearTimeout(this.timeoutId);
      this.setState({ tooltipVisible: false });
    });
    __publicField(this, "wrappChildrenProp", (propName, func) => {
      return {
        [propName]: (e) => {
          func(e);
          this.props.children.props[propName]?.(e);
        }
      };
    });
    __publicField(this, "wrapperProps", {
      ...this.wrappChildrenProp("onMouseEnter", this.showTooltip),
      ...this.wrappChildrenProp("onMouseLeave", this.hideTooltip),
      ...this.wrappChildrenProp("onClick", this.hideTooltip),
      ...this.wrappChildrenProp("onMouseMove", this.onMouseMove)
    });
  }
  componentDidUpdate() {
    this.disabled = window.richContentHideTooltips;
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }
  render() {
    const {
      children,
      content,
      isError,
      place,
      tooltipOffset,
      followMouse,
      hideArrow,
      forceVisibility
    } = this.props;
    const { tooltipVisible } = this.state;
    const { isMobile } = this.context;
    const style = getTooltipStyles(isError, followMouse, tooltipOffset, place);
    const elementProps = forceVisibility || tooltipVisible ? { ...this.wrapperProps, "data-tooltipid": true } : this.wrapperProps;
    const tooltipArrow = hideArrow ? null : "center";
    return isMobile || this.disabled || !content ? children : /* @__PURE__ */ React.createElement(React.Fragment, null, React.cloneElement(React.Children.only(children), elementProps), forceVisibility || tooltipVisible ? /* @__PURE__ */ React.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React.createElement(
      ToolTipComponent,
      {
        active: forceVisibility || tooltipVisible,
        parent: "[data-tooltipid=true]",
        position: place,
        arrow: tooltipArrow,
        style,
        tooltipTimeout: 10,
        group: "ricos"
      },
      content
    )) : null);
  }
}
__publicField(Tooltip, "defaultProps", {
  isError: false,
  place: "top",
  tooltipOffset: { x: 0, y: 0 }
});
__publicField(Tooltip, "contextType", GlobalContext);
var Tooltip_default = Tooltip;
export {
  Tooltip_default as default
};
//# sourceMappingURL=Tooltip.js.map
